import List from './List'

export const tabs = [
    {
        label: 'contract-list',
        value: 'list',
        component: <List />,
    },
]
